import { timeout } from 'rxjs/operators'

import { get, post } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

const BASE_URL = '/members-api/psa/integrations'

// Must exceed the server's slowest save, about 80 s (a 15 s read, the 60 s write, a 5 s
// read-back), so a save that succeeds late is never shown as failed; the proxy stops at 90 s.
// Wizard actions finish sooner, and the same bound ends one the server never answers.
const REQUEST_TIMEOUT_MS = 85000

const sanitizeSegment = (segment = '') => encodeURIComponent(String(segment).trim())

const withCompanyFilter = (url, companyFilter = '') =>
  buildURL(url, {
    companyFilter,
  })

export default function psaIntegrations() {
  return {
    getWizardSchema(providerKey, companyFilter = '') {
      const provider = sanitizeSegment(providerKey)
      return get(withCompanyFilter(`${BASE_URL}/${provider}/wizard-schema/`, companyFilter))
    },

    getIntegrationConfig(providerKey, companyFilter = '') {
      const provider = sanitizeSegment(providerKey)
      return get(withCompanyFilter(`${BASE_URL}/${provider}/config/`, companyFilter))
    },

    // The tile needs only `configured` and `status`; the full answer carries every client and
    // product mapping, which for a large MSP is a big download for one status dot.
    getIntegrationStatus(providerKey, companyFilter = '') {
      const provider = sanitizeSegment(providerKey)
      return get(buildURL(`${BASE_URL}/${provider}/config/`, { companyFilter, summary: 1 }))
    },

    runWizardAction(providerKey, actionType, payload = {}, companyFilter = '') {
      const provider = sanitizeSegment(providerKey)
      const action = sanitizeSegment(actionType)
      return post(
        withCompanyFilter(`${BASE_URL}/${provider}/wizard-actions/${action}/`, companyFilter),
        payload
      ).pipe(timeout(REQUEST_TIMEOUT_MS))
    },

    saveIntegration(providerKey, payload = {}, companyFilter = '') {
      const provider = sanitizeSegment(providerKey)
      return post(withCompanyFilter(`${BASE_URL}/${provider}/save/`, companyFilter), payload).pipe(
        timeout(REQUEST_TIMEOUT_MS)
      )
    },

    disableIntegration(providerKey, companyFilter = '') {
      const provider = sanitizeSegment(providerKey)
      return post(withCompanyFilter(`${BASE_URL}/${provider}/disable/`, companyFilter), {})
    },
  }
}
